module.exports = __webpack_public_path__ + "static/media/Qt.97ad090b.svg";